import React, { Dispatch, SetStateAction } from 'react';
import { Modal } from '../../../components/common/modal/modal';
import RecallsAccordion from './recalls-accordion';
import CspAccordion from './csp-accordion';
import { VehicleAttributes } from '../../../models/vehicle-attributes';
import { RecallsProps } from '../recalls/hook/use-recalls-content';
import { ExemptWordsListProps } from '../recalls/hook/use-exempt-word-list';
import { RecallsApiResponse } from '../../../services/recalls-service/recalls-service';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import { RecallsApiResponseWithLoading } from '../../../components/sections/vehicle-portal/hooks/use-recall-data';
import { nameplateMakeModelYearUtil } from '../../../components/utils/nameplate-model-year-util/nameplate-make-model-year-util';
import { RecallsCspDisclaimer } from './recalls-csp-disclaimer';
import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';

interface Props {
    vehicleAttributes: VehicleAttributes;
    year: string;
    recallsContent: RecallsProps;
    isYmm: boolean;
    modalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    displayName: string;
    vinToSearch: string;
    loadTime: number | undefined;
    isWebview: boolean;
    recallErrorMsg: string;
    showRecalls: boolean;
    exemptWordsContent: ExemptWordsListProps | null;
    recallData: RecallsApiResponse | null | undefined;
    isLincoln: boolean;
    model: string;
    showCsp: boolean;
    recallApiResponse: RecallsApiResponseWithLoading | null;
    appConfig: AppConfigurationService;
    isImgTakataCampaignIdPresent: boolean;
    isImgTakataRoute: boolean;
}

export const RecallsVehicleInformation = (props: Props) => {
    const loadTime =
        props.loadTime && props.loadTime !== null && props.loadTime > 10;

    return props.recallApiResponse?.loading ? (
        <ActivityIndicator />
    ) : (
        <>
            {(props.vehicleAttributes.year > 0 || +props.year > 0) && (
                <div
                    className="vehicle-information"
                    id="vehicle-information"
                    data-testid="vehicle-information"
                >
                    {!props.recallsContent.hideVehicleLabelWithDetail && (
                        <>
                            {props.isYmm && (
                                <>
                                    <div className="ymm-recalls-subtitle">
                                        {
                                            props.recallsContent
                                                .ymmRecallsSubtitle
                                        }
                                    </div>
                                    <Modal
                                        name="ymmAlert"
                                        role="dialog"
                                        aria-label="Recall Search through YMM Disclaimer"
                                        isVisible={props.modalVisible}
                                        primaryBtnLabel="Close"
                                        onPrimaryBtnClick={() =>
                                            props.setModalVisible(false)
                                        }
                                        preventClose={true}
                                    >
                                        {
                                            props.recallsContent
                                                .ymmRecallsSubtitle
                                        }
                                    </Modal>
                                </>
                            )}
                            <div className="vehicle-information-ym">
                                {nameplateMakeModelYearUtil(
                                    props.displayName ||
                                        props.vehicleAttributes.model,
                                    props.year || props.vehicleAttributes.year
                                )}
                            </div>
                        </>
                    )}
                    {props.vinToSearch && (
                        <div>
                            <span className="vehicle-information-label">
                                {props.recallsContent.detailsVinLabel}
                            </span>
                            :
                            <span className="vehicle-information-vin">
                                {props.vehicleAttributes.vin}
                            </span>
                        </div>
                    )}
                </div>
            )}
            {loadTime && props.isWebview ? (
                <div className="recalls-error-message">
                    {props.recallsContent.recallsLoadError}
                </div>
            ) : (
                !props.recallErrorMsg &&
                props.recallsContent && (
                    <div
                        className="recalls-csp-accordions"
                        data-testid="recalls-csp-accordions"
                    >
                        {props.showRecalls &&
                            RecallsAccordion({
                                exemptWordsContent: props.exemptWordsContent,
                                recallData: props.recallData,
                                recallsContent: props.recallsContent,
                                isWebview: props.isWebview,
                                isYmm: props.isYmm,
                                isLincoln: props.isLincoln,
                                model: props.model,
                                isImgTakataCampaignIdPresent:
                                    props.isImgTakataCampaignIdPresent,
                                isImgTakataRoute: props.isImgTakataRoute,
                            })}
                        {props.showCsp &&
                            CspAccordion(
                                props.exemptWordsContent,
                                props.recallData,
                                props.recallsContent,
                                props.isWebview,
                                props.isYmm,
                                props.isLincoln
                            )}
                    </div>
                )
            )}
            <RecallsCspDisclaimer
                appConfig={props.appConfig}
                recallData={props.recallData}
                recallsContent={props.recallsContent}
                showRecalls={props.showRecalls}
                showCsp={props.showCsp}
                isYmm={props.isYmm}
                isImgTakataCampaignIdPresent={
                    props.isImgTakataCampaignIdPresent
                }
                isImgTakataRoute={props.isImgTakataRoute}
            />
        </>
    );
};
